import React, { useRef } from 'react';
import { Button } from 'reactstrap';
import TableHead from '@material-ui/core/TableHead';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setCadsAiModuleFilters } from '../../redux/actions';

export function ModuleTableSearchBar() {
  const dispatch = useDispatch();
  const totalModuleCount = useSelector((state) => state.cadsAIModule.totalRecords, shallowEqual);
  const [isSearched, setIsSearched] = React.useState(false);
  const searchRef = useRef(null);

  const handleSearch = () => {
    setIsSearched(true);
    dispatch(setCadsAiModuleFilters({ searchText: searchRef?.current?.value, pageNumber: 1 }));
  };

  const handleClear = () => {
    if (searchRef?.current?.value) searchRef.current.value = '';
    setIsSearched(false);
    dispatch(setCadsAiModuleFilters({ searchText: '', pageNumber: 1 }));
  };

  return (
    <TableHead>
      <div className="table__search">
        <div className="table__search_item">
          <b>Module Name</b>
          <div className="form">
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="form__form-group-icon" style={{ height: 37 }}>
                  <MagnifyIcon />
                </div>
                <input
                  ref={searchRef}
                  className="search-bar-search-text"
                  name="searchText"
                  type="text"
                  placeholder="Search by module name"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table__search_item mt-3">
          <Button color="primary" onClick={handleSearch}>
            {' '}
            Search{' '}
          </Button>
        </div>
        <div className="table__search_item mt-3">
          <Button color="secondary" onClick={handleClear} outline>
            Clear
          </Button>
        </div>
      </div>

      {isSearched && (
        <div className="ml-1">
          <span>Found {totalModuleCount} matches</span>
        </div>
      )}
    </TableHead>
  );
}
